export default function () {
  const cart = document.querySelector('#ordersFirstStepTable');
  const certificate = document.querySelector('#ordersSecondStepTable');
  if(cart){
    const products = cart.querySelectorAll('.table__row');
    products.forEach((product) => {
      if (product.querySelector('input[type=text]')){
        product.querySelector('input').addEventListener('change', (e)=> {
          let data = [
              {
                id: e.target.dataset.id,
                quantity: e.target.value
              }
            ];
          updateCart(true, e, data, product);
        })
      }

      if (product.querySelector('.table-button--remove')) {
        product.querySelector('.table-button--remove').addEventListener('click', (e)=> {
          deleteFromCart(e.target.closest('.table__row'));
        })
      }
    })
  }
  if (certificate) {
    const checkAllCertificatesBtn = document.querySelector('#all');
    const products = certificate.querySelectorAll('.table__row');
    products.forEach((product) => {
      if (product.querySelector('input[type=checkbox]').dataset.id) {
        product.querySelector('input').addEventListener('change', (e)=> {
          let data = [
            {
              id: e.target.dataset.id,
              certificateRequest: product.querySelector('input').checked
            }
          ];
          updateCart(false, e, data);
        })
      }
    });
    checkAllCertificatesBtn.addEventListener('change', (e)=> {
      e.preventDefault();
      let data = [];
      products.forEach((product) => {
        if (product.querySelector('input[type=checkbox]').dataset.id){
          data.push(
              {
                id: product.querySelector('input[type=checkbox]').dataset.id,
                certificateRequest: checkAllCertificatesBtn.checked
              }
          );
        }
      });
      updateCart(false, '', data )
    })
  }

  const showSummaryLoader = () => {
    const summary = document.querySelector('.summary-box__top');
    if (summary && !summary.querySelector('.summary-box__loader')) {
      const loader = document.createElement('div');
      loader.className = 'summary-box__loader';
      summary.appendChild(loader);
    }
    const submitBtn = document.querySelector('.summary-box .btn--orders');
    if (submitBtn) {
      submitBtn.classList.add('btn--disabled');
      submitBtn.setAttribute('disabled', 'disabled');
    }
  };

  const hideSummaryLoader = () => {
    const loader = document.querySelector('.summary-box__loader');
    if (loader) loader.remove();
    const submitBtn = document.querySelector('.summary-box .btn--orders');
    if (submitBtn) {
      submitBtn.classList.remove('btn--disabled');
      submitBtn.removeAttribute('disabled');
    }
  };

  const updateCart = (isFirstStep, inputEvnt, data, product) => {
    const lang = document.getElementsByTagName("html")[0].getAttribute("lang");
    let cookies = document.cookie.split(';').slice(1).join();
    const headers = new Headers();
    headers.append('Cookie', cookies);
    showSummaryLoader();
    fetch(`/api/${lang}/cart/update`, {
      method: "PATCH",
      headers: headers,
      body: JSON.stringify(data)
    }).then(res => res.json()).then(data =>{
      if(isFirstStep) {
        changePrices(product, inputEvnt.target.value, false, data)
      }
      updateTierDisplay(data);
      updateTierBadge(data);
      hideSummaryLoader();
    })
        .catch(err => { console.log(err); hideSummaryLoader(); })
  };

  const deleteFromCart = (product) => {
    const id = product.querySelector('input[type=text]').dataset.id;
    const quantity =  product.querySelector('input[type=text]').value;
    const lang = document.getElementsByTagName("html")[0].getAttribute("lang");
    let cookies = document.cookie.split(';').slice(1).join();
    const headers = new Headers();
    headers.append('Cookie', cookies);
    showSummaryLoader();
    fetch(`/api/${lang}/cart/items/${id}`, {
      method: "DELETE",
      headers: headers,
    }).then(res => res.json()).then(data =>{
        changePrices(product, quantity, true, data);
      product.remove();
      updateTierDisplay(data);
      updateTierBadge(data);
      hideSummaryLoader();
    })
        .catch(err => { console.log(err); hideSummaryLoader(); })
  };

  const changePrices = (product, productQuantity, deleteItem, data) => {
    const itemPrice = parseFloat(product.querySelector('[data-item-price]').innerHTML.replace(",", ""));
    const itemNetto = product.querySelector('[data-netto-price]');
    const totalNetto = document.querySelector('[data-total-netto]');
    const totalBrutto = document.querySelector('[data-total-brutto]');

    document.querySelector('.cart-bar__count').textContent = data.itemsCount;

    const badge = document.querySelector('.cart-bar__badge');

    if(data.itemsCount>0){
      badge.classList.add('cart-bar__badge--active');
    }else{
      badge.classList.remove('cart-bar__info--active')
      document.location.reload(true);
    }

    if(!deleteItem){
      itemNetto.innerHTML = ((itemPrice * productQuantity)).toLocaleString("en-US", { minimumFractionDigits: 2 });
    }

    totalNetto.innerHTML = parseFloat(data.totalNetto).toLocaleString("en-US", { minimumFractionDigits: 2 });
    totalBrutto.innerHTML = parseFloat(data.totalBrutto).toLocaleString("en-US", { minimumFractionDigits: 2 });
  };

  const updateTierDisplay = (data) => {
    if (!data.discountInfo) return;

    const container = document.querySelector('.summary-box__top');
    if (!container) return;

    const info = data.discountInfo;
    const totalNetto = parseFloat(data.totalNetto);
    const isTier = info.source === 'tier';
    const hasDiscount = parseFloat(info.discountPercent) > 0;

    const discountTpl = isTier ? container.dataset.tplDiscountTier : container.dataset.tplDiscountDefault;
    const afterDiscountTpl = isTier ? container.dataset.tplAfterDiscountTier : container.dataset.tplAfterDiscountDefault;

    const discountSection = container.querySelector('.summary-box__discount');
    const afterDiscountSection = container.querySelector('.summary-box__netto-after-discount');

    if (discountSection) {
      discountSection.style.display = hasDiscount ? '' : 'none';
      if (hasDiscount) {
        discountSection.querySelector('span:first-child').innerHTML =
          discountTpl.replace('__PERCENT__', info.discountPercent);
        discountSection.querySelector('[data-customer-discount]').innerHTML = info.discountPercent;
        discountSection.querySelector('[data-total-discount]').innerHTML =
          '- ' + parseFloat(data.discount).toLocaleString("en-US", { minimumFractionDigits: 2 });
      }
    }

    if (afterDiscountSection) {
      afterDiscountSection.style.display = hasDiscount ? '' : 'none';
      if (hasDiscount) {
        var discountAmount = totalNetto * (info.discountPercent / 100);
        afterDiscountSection.querySelector('span:first-child').innerHTML =
          afterDiscountTpl + ':';
        afterDiscountSection.querySelector('[data-total-netto-original]').innerHTML =
          totalNetto.toLocaleString("en-US", { minimumFractionDigits: 2 });
        afterDiscountSection.querySelector('[data-total-netto-discounted]').innerHTML =
          (totalNetto - discountAmount).toLocaleString("en-US", { minimumFractionDigits: 2 });
      }
    }

  }

  const updateTierBadge = (data) => {
    const badge = document.querySelector('[data-tier-badge]');
    if (!badge || !data.discountInfo) return;

    const info = data.discountInfo;

    if (data.itemsCount === 0) {
      badge.classList.remove('cart-bar__tier-badge--active');
      return;
    }

    if (info.hasTiers && info.amountToNextTier !== null) {
      badge.classList.add('cart-bar__tier-badge--active');
      const valueEl = badge.querySelector('.cart-bar__tier-badge-value');
      const discountEl = badge.querySelector('.cart-bar__tier-badge-discount');

      if (valueEl) {
        valueEl.textContent = parseFloat(info.amountToNextTier).toLocaleString("en-US", {minimumFractionDigits: 0}) + ' ' + badge.dataset.currency;
      }
      if (discountEl && badge.dataset.tplDiscount) {
        discountEl.textContent = badge.dataset.tplDiscount.replace('__PERCENT__', info.nextTierPercent);
      }
    } else {
      badge.classList.remove('cart-bar__tier-badge--active');
    }
  }
}